import styled from "styled-components";

export const StyledLabel = styled.label`
  gap: ${(props) => (props.gap ? props.gap : 0)};
  margin: ${(props) => (props.margin ? props.margin : "8px 0 0 0")};
  font-size: ${(props) => props.fontSize || "0.875rem"};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 'regular')};

  span {
    color: ${(props) => props.theme.colors.red500};
    margin-left: 0.25rem;
  }
`;
